import { render } from "./EvolutionSplit.vue?vue&type=template&id=236b1d4b&scoped=true"
import script from "./EvolutionSplit.vue?vue&type=script&lang=js"
export * from "./EvolutionSplit.vue?vue&type=script&lang=js"

import "./EvolutionSplit.vue?vue&type=style&index=0&id=236b1d4b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236b1d4b"]])

export default __exports__